module.exports = __webpack_public_path__ + "static/media/Vas.78a0c04a.svg";